import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import Footer from '../components/Footer';
import CoverImage from '../assets/img/About/Abouts.webp';

const Contactus = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs.send(
      'service_wa76lmp', // Your EmailJS service ID
      'template_ajr4fjb', // Your template ID
      {
        full_name: formData.fullName,
        email: formData.email,
        phone: formData.phone,
        message: formData.message,
      },
      '7CgziywId045J0XQp' // Your public key
    )
    .then(() => {
      alert('Your form has been submitted successfully. We will get back to you soon..');
      setFormData({ fullName: '', email: '', phone: '', message: '' });
    })
    .catch((error) => {
      console.error('Error sending message:', error);
      alert('Failed to send message. Please try again.');
    });
  };

  return (
    <div className="text-[#121C3D]">
      {/* Hero Section */}
      <section
        className="relative bg-cover bg-center h-[60vh] md:h-[80vh] flex items-center justify-center"
        style={{ backgroundImage: `url(${CoverImage})` }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-60" />
        <div className="relative z-10 text-white text-center px-4">
          <h1 className="text-3xl md:text-4xl font-bold uppercase mt-4 p-4 tracking-wider font-playfair">
            Contact Us
          </h1>
          <p className="text-xl font-light uppercase mt-2 tracking-wider font-playfair">
            We’d love to hear from you. Get in touch!
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12">
          {/* Contact Form */}
          <div>
            <h2 className="text-2xl font-bold text-[#8C2F39] font-playfair mb-4">Send Us a Message</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                type="text"
                name="fullName"
                placeholder="Full Name"
                value={formData.fullName}
                onChange={handleChange}
                required
                className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:border-gray-500 focus:ring-1 focus:ring-gray-400"
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:border-gray-500 focus:ring-1 focus:ring-gray-400"
              />
              <input
                type="tel"
                name="phone"
                placeholder="Phone"
                value={formData.phone}
                onChange={handleChange}
                required
                className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:border-gray-500 focus:ring-1 focus:ring-gray-400"
              />
              <textarea
                name="message"
                placeholder="Your Message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
                className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:border-gray-500 focus:ring-1 focus:ring-gray-400"
              ></textarea>
              <button
                type="submit"
                className="bg-[#8C2F39] font-playfair text-white px-6 py-2 rounded hover:bg-[#a03b45] transition"
              >
                Send Message
              </button>
            </form>
          </div>

          {/* Contact Info and Map */}
          <div>
            <h2 className="text-2xl font-bold text-[#8C2F39] mb-4 font-playfair">Our Location</h2>
            <div className="space-y-3 mb-4">
              <div className="flex items-start space-x-2">
                <i className="fa-solid fa-location-dot text-[#90444D]" />
                <span>24 Kokeb Hintsa in front of the Eritrean Embassy, Addis Ababa, Ethiopia</span>
              </div>
              <div className="flex items-start space-x-2">
                  <i className="fa-solid fa-envelope text-[#90444D]" />
                  <div>
                    <p>cccea@ccfcea.org</p>
                    <p>christaincare1@gmail.com</p>
                  </div>
                </div>
              <div className="flex items-start space-x-2">
                <i className="fa-solid fa-phone text-[#90444D]" />
                <div>
                  <p>+251 116 66 28 80</p>
                  <p>+251 911 25 74 03</p>
                </div>
              </div>
              <div className="flex items-start space-x-2">
                  <i className="fa-solid fa-envelopes-bulk text-[#90444D]"></i>
                  <span>P.O.BOX 21154</span>
                </div>
            </div>
            <div className="w-full h-64">
              <iframe
                className="w-full h-full"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.5811531297536!2d38.79885657483265!3d9.01063169104997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x164b85b334fcb5cb%3A0xe9f05f22b00070b3!2sERITREA%20EMBASSY!5e0!3m2!1sen!2set!4v1745323307831!5m2!1sen!2set"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Google Maps location of Megenagna, Addis Ababa, Ethiopia"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <section className="bg-black/90">
        <Footer />
      </section>
    </div>
  );
};

export default Contactus;
